import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { SubscribeParams } from '@fantaz/shared/data-access/models/src/lib/subscribe';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SubscribeApiService {
  constructor(private http: HttpClient) {}

  postSubscribeToTournament(
    params: SubscribeParams,
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${environment.apiBaseUrl}/event-api/coming-soon/${params.eventPrototypeUuid}/${params.eventScheduleUuid}`,
      {
        name: params.name,
        email: params.email,
      },
    );
  }
  deleteSubscribeToTournament(
    params: SubscribeParams,
  ): Observable<{ message: string }> {
    const parsedEmail = params.email.replace('+', '%2B');
    return this.http.delete<{ message: string }>(
      `${environment.apiBaseUrl}/event-client/api/coming-soon/${params.eventPrototypeUuid}/${params.eventScheduleUuid}?email=${parsedEmail}`,
    );
  }
}
